import axios from "axios";
import { Dialog, Toast } from "vant";
import store from "@/store";
import { getToken } from "@/util/auth";
Toast.setDefaultOptions({ duration: 4000 });
const check401 = (res) => {
  if (res.code === 401) {
    // to re-login
    store.dispatch("user/resetToken").then(() => {
      location.reload();
    });
  }
};

const rejectBlobResponse = (response) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    let res;
    try {
      res = JSON.parse(reader.result) || {};
    } catch (error) {
      res = { message: "模板下载失败，请稍后重试" };
    }
    Toast(res.message || "模板下载失败，请稍后重试");
    check401(response.status === 401 ? { code: 401 } : res);
    reject(new Error(res.message || "模板下载失败"));
  };
  reader.onerror = () => {
    Toast("模板下载失败，请稍后重试");
    reject(new Error("模板下载失败"));
  };
  reader.readAsText(response.data);
});
// create an axios instance
const service = axios.create({
  baseURL: "/api/", // url = base url + request url
  // baseURL: 'http://47.95.232.65:80/api/',// 微信调试
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["token"] = getToken();
    }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;
    if (response.config.responseType === "blob") {
      const contentType = response.headers["content-type"] || res.type || "";
      return contentType.includes("json") ? rejectBlobResponse(response) : res;
    }
    const isIpSmsVerification =
      response.config.acceptIpSmsVerification === true && res.code === 4002;
    // console.log(res, 90);
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200 && !isIpSmsVerification) {
      Toast(res.message || "Error");
      check401(res);
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    if (error.config && error.config.responseType === "blob") {
      if (error.response) return rejectBlobResponse(error.response);
      Toast("模板下载失败，请稍后重试");
      return Promise.reject(error);
    }
    console.log("err" + error); // for debug
    if (error.response.data.code !== 401) Toast(error.message);
    check401(error.response.data);
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/http/index.js